import { FormationFirestorePersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const FormationPersistenceProvider = createStaticContextProvider(
  FormationFirestorePersistenceContext,
  lazyValue(() =>
    import("./formation-persistence").then(
      (module) => module.formationPersistence,
    ),
  ),
);
